import { Reveal } from "@/components/Reveal";

export const Chapter = ({ eyebrow, title, lede }) => (
  <div className="mb-14">
    <Reveal>
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-safety mb-4">{eyebrow}</p>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight text-navy max-w-3xl">
        {title}
      </h2>
    </Reveal>
    {lede && (
      <Reveal delay={0.2}>
        <p className="mt-5 max-w-2xl text-base md:text-lg text-steel leading-relaxed">{lede}</p>
      </Reveal>
    )}
  </div>
);
